import React from 'react';
import { Box } from '@chakra-ui/react';
import {
  Pie,
  PieChart,
  ResponsiveContainer,
  Tooltip,
  Cell,
  Legend,
} from 'recharts';

export interface Props {
  data: {
    name: string;
    value: number;
  }[];
}

const COLORS = [
  { cell: '#01BFF3', text: '#000000' },
  { cell: '#256B8A', text: '#ffffff' },
  { cell: '#ABD8F2', text: '#000000' },
  { cell: '#E6F5FC', text: '#000000' },
];

const RADIAN = Math.PI / 180;

const renderCustomizedLabel = ({
  cx,
  cy,
  midAngle,
  innerRadius,
  outerRadius,
  percent,
  index,
}: any) => {
  const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  return (
    <text
      x={x}
      y={y}
      fill={COLORS[index % COLORS.length].text}
      textAnchor={x > cx ? 'start' : 'end'}
      dominantBaseline="central"
    >
      {`${(percent * 100).toFixed(0)}%`}
    </text>
  );
};

const renderLegendText = (value: string) => {
  return <span style={{ color: '#fff' }}>{value}</span>;
};

const DonutChart: React.FC<Props> = ({ data }: Props) => {
  return (
    <Box w="400px" h="300px">
      <ResponsiveContainer width="100%" height="100%">
        <PieChart width={400} height={300}>
          <Pie
            data={data}
            labelLine={false}
            label={renderCustomizedLabel}
            innerRadius="50%"
            dataKey="value"
          >
            {data.map((entry, index) => (
              <Cell
                key={`cell-${index}`}
                fill={COLORS[index % COLORS.length].cell}
                stroke="none"
              />
            ))}
          </Pie>
          <Legend
            layout="vertical"
            verticalAlign="middle"
            align="right"
            formatter={renderLegendText}
          />
        </PieChart>
      </ResponsiveContainer>
    </Box>
  );
};

export default DonutChart;
